import { Injectable, inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, first } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';

import { LayoutService } from '../layout.service';
import { LayoutActions } from '../actions';
import { ProductService } from '../product.service';

import { Product } from 'src/objects/product';




@Injectable()
export class LayoutEffects {
  private actions$ = inject(Actions);
  private layoutService = inject(LayoutService);
  private productService = inject(ProductService);

  templatedLayoutPositions$ = createEffect(() => this.actions$
    .pipe(
      ofType(LayoutActions.loadTemplatedLayoutPositionsWithInventoryUnits),
      switchMap(({ dateOfStay, mappedArea }) => forkJoin([
          this.layoutService.getTemplatedLayoutPositions({ dateOfStay, mappedArea }),
          this.layoutService.getTemplatedLayoutSections({ dateOfStay, mappedArea }),
          this.layoutService.getTemplatedLayoutInventoryUnits({ dateOfStay, mappedArea }),
        ])
        .pipe(
          switchMap(([positions, sections, inventoryUnits]) => {
            const productIds = [
              ...new Set(
                inventoryUnits
                  .filter(p => p.product_id !== null && p.product_id !== undefined)
                  .map(p => p.product_id)
              )
            ];

            return forkJoin(productIds.map(id => this.productService.get(id).pipe(first(), catchError(() => of(null)))))
              .pipe(
                map((products: (Product | null)[]) => products.filter(prod => !!prod)),
                map((products: Product[]) => ({ positions, inventoryUnits, products: products.filter(prod => !!prod), sections })),
                catchError(() => of({ positions, inventoryUnits, products: [], sections })),
              );
          }),
          map(({positions, inventoryUnits, products, sections}) => LayoutActions
            .loadTemplatedLayoutPositionsWithInventoryUnitsSuccess({ positions, inventoryUnits, products, sections })),
          catchError(error => of(LayoutActions.loadTemplatedLayoutPositionsWithInventoryUnitsFailure({ error }))),
        ),
      ),
    ),
  );

  templatedLayoutLandmarks$ = createEffect(() => this.actions$
    .pipe(
      ofType(LayoutActions.loadTemplatedLayoutLandmarks),
      switchMap(payload => this.layoutService
        .getTemplatedLayoutLandmarks(payload)
        .pipe(
          map(layoutLandmarks => LayoutActions.loadTemplatedLayoutLandmarksSuccess({ layoutLandmarks })),
          catchError(error => of(LayoutActions.loadTemplatedLayoutLandmarksFailure({ error }))),
        ), 
      ),
    ),
  );
}

